export const schedule = () => (
  <path
    d="M20 8V5a2 2 0 00-2-2H4a2 2 0 00-2 2v14a2 2 0 002 2h5M2 9h8m7 5.75V17l2.4 1.2M15 1v4M7 1v4m16 12a6 6 0 11-12 0 6 6 0 0112 0z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
